.caption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  padding: 10px;
  background-color: var(--main-text);
  color: #fff;
}

.caption-label {
  font-size: 20px;
  padding-right: 5px;
}

.pointer {
  cursor: pointer;
}

.navigation {
  margin-left: auto;
}

.nav-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  padding: 0.25em;
  border-radius: 100%;
  border: 0;
}

.nav-button:hover {
  cursor: pointer;
  background-color: #fff;
  color: var(--main-text);
}
